import React from "react";
import { Button } from "react-bootstrap";
import { FaPlayCircle, FaPauseCircle } from "react-icons/fa";
import { setUserInfo } from "./../../../lib/session";
import "./index.less";

export default props => {
  const { post, currentlyPlaying, playVideo, track, designType } = props;
  const togglePlay = (currentlyPlaying, videoId, audioFile, playVideo) => {
    if (audioFile && currentlyPlaying !== audioFile) {
      audioFile && videoId && playVideo(audioFile);
      track("listen-audio", audioFile, ({ data }) => {
        const { trackActivity: { user: userData } = {} } = data || {};
        setUserInfo("data", userData);
      });
    } else {
      playVideo(false);
    }
  };

  const {
    videoId,
    title,
    mediaDetails: { videoThumbnail: { sourceUrl } = {} } = {},
    audioSettings: { audio } = {}
  } = post;
  const audioFile = audio ? audio.mediaItemUrl : "";

  return (
    <Button
      onClick={() =>
        togglePlay(currentlyPlaying, videoId, audioFile, playVideo)
      }
      className={`audio-card ${designType}`}
    >
      {sourceUrl && (
        <img
          src={
            sourceUrl // If a featured image exists, display it.
          }
          alt={title}
          className="image"
        />
      )}
      {audioFile && currentlyPlaying !== audioFile && (
        <FaPlayCircle className="play-icon" size="45" color="#ccc" />
      )}
      {audioFile && currentlyPlaying === audioFile && (
        <>
          <FaPauseCircle className="play-icon" size="45" color="#ccc" />
          <div>
            <div className="audio-playing" />
            <div className="play-text">Playing</div>
          </div>
        </>
      )}
      <div>
        <h3 className="heading">{title}</h3>
      </div>
    </Button>
  );
};
